var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('CustomSideBar'),_c('div',{staticClass:"row",staticStyle:{"padding-left":"60px"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }